import React, {Component} from 'react'
import {Trans, withTranslation} from 'react-i18next'

import './styles.scss'
import DefaultLayout from '../../DefaultLayout'
import Box from "../../../Shared/Box";
import {Col, Container, Row} from "../../../Shared/Grid";
import Button from "../../../Shared/Form/Button";
import HotelChainBanner from "../../../Shared/HotelChainBanner";

class HotelChainPage extends Component {
    render() {
        const {t} = this.props
        return (
            <DefaultLayout>
                <div className={'hotel-chain-page'}>
                    <Box>
                        <Container className="hotel-chain-page-container" fluid gutterWidth={0}>
                            <Row>
                                <Col className={'weighted-text'} xs={12}>
                                    <Trans i18nKey={'HOTEL_CHAIN_NOTE_ONE'}/>
                                </Col>
                            </Row>
                            <Row>
                                <Col className={'weighted-text'} xs={12}>
                                    <Trans i18nKey={'HOTEL_CHAIN_NOTE_TWO'}/>
                                </Col>
                            </Row>
                            <Row style={{marginTop: '80px'}}>
                                <Col xs={12}>
                                    <a href={t('URL_HOTEL_CHAIN_CONTACT')} target="_blank" rel="noreferrer">
                                        <Button classNames={'Button-CTA Button-Rounded-Side contact-button'}>
                                            {t('CONTACT_US')}
                                        </Button>
                                    </a>
                                </Col>
                            </Row>
                            {/*<Row>*/}
                            {/*    <Col className={'weighted-text'} xs={12}>*/}
                            {/*        <Trans i18nKey={'HOTEL_CHAIN_NOTE_THREE'}>*/}
                            {/*            <a className={'weighted-text'} href={'/search'}> </a>*/}
                            {/*        </Trans>*/}
                            {/*    </Col>*/}
                            {/*</Row>*/}
                        </Container>
                    </Box>
                    <Box style={{marginTop: 'auto', marginBottom: '25px'}}>
                        <Row>
                            <Col xs={12}>
                                <HotelChainBanner/>
                            </Col>
                        </Row>
                    </Box>
                </div>
            </DefaultLayout>
        )
    }
}

export default withTranslation()(HotelChainPage)
